<template>
  <div class="wrap">
    <header>
      <span class="iconfont icon-back-left" @click="goBack"></span>
      <h2>{{depositType}} 充值</h2>
    </header>
    <div class="main">
      <p class="title">汇款地址</p>
      <p class="navbar">
        <span v-for="(item,index) in currency" :key="index" :class="{'active':type==item.Id}" @click="choseType(item.Id,index)">{{item.Protocol}}</span>
      </p>
      <p class="item">
        <span>{{address}}</span>
        <span class="btn tag-read" :data-clipboard-text="address" @click="copydz">复制地址</span>
      </p>
      <p class="title">充值金额</p>
      <p class="item">
        <input type="text" :placeholder="lang.enMoney" v-model="amount">
      </p>
      <!-- <p class="title">付款凭证</p>
      <p class="item nobg" @click="chosePic">
        <img v-if="imageUrl" :src="imageUrl" width="150">
        <span class="addimg" v-else><i class="iconfont icon-tianjia"></i></span>
        <input name="upf" @change="getPath" id="filed" type="file" accept="image/*">
      </p> -->
      <div class="next-btn" @click="submit">{{lang.confirm}}</div>
    </div>
  </div>
</template>
<script type="text/javascript">
  import {
    mapState
  } from 'vuex'
  import Clipboard from 'clipboard';
  export default {
    data() {
      return {
        depositType: '',
        type: '',
        address: '',
        amount:'',
        currency:[],
        imageUrl: ''
      }
    },
    created() {
      this.depositType = this.$route.query.type;
      this.currency = this.$route.query.payInfo;
      this.type = this.currency[0]['Id'];
      this.address = this.currency[0]['Addr'];
      this.amount = '';
    },
    computed: {
      ...mapState(['lang', 'userInfo'])
    },
    methods: {
      goBack() {
        this.$router.go(-1)
      },
      choseType(id,i){
        this.type = id;
        this.address = this.currency[i]['Addr'];
      },
      copydz() {
        var clipboard = new Clipboard('.tag-read')
        clipboard.on('success', e => {
          this.$toast({
            message: this.lang.copysucc,
            position: 'middle',
            iconClass: 'iconfont icon-chenggong'
          });
          // 释放内存
          clipboard.destroy()
        })
        clipboard.on('error', e => {
          // 不支持复制
          this.$toast({
            message: this.lang.copyDefault,
            position: 'middle',
            iconClass: 'icon icon-shibai'
          });
          // 释放内存
          clipboard.destroy()
        })
      },
      chosePic() { //选择图片
        let filed = document.getElementById('filed')
        filed.value = ''
        filed.click()
      },
      getPath() { //显示图片
        let filed = document.getElementById('filed');
        let fileObj = filed.files[0];
        var reader = new FileReader();
        reader.readAsDataURL(fileObj);
        let _this = this;
        reader.onload = function () {
          // 获取文件信息
          _this.imageUrl = reader.result;
        };
      },
      submit(){
        this.$indicator.open(this.lang.loading);
        this.$doRequest('post', '/user/depositDCoin',{
          id:this.type,
          amt:this.amount,
          myAddr:this.address
        })
          .then(res => {
            this.$indicator.close();
            if (res.data.err == 0) {
              this.$toast({
                message: res.data.msg,
                position: 'middle',
                iconClass: 'icon icon-chenggong'
              });
              setTimeout(()=>{
                this.$router.push('Index')
              },2000)
            } else if (res.data.err == 102) {
              this.$router.push('Login');
              localStorage.setItem('tk', res.data.tk);
            } else if (res.data.err == 200 || res.data.err == 201) {
              this.$router.push({
                name: 'Maintenance',
                query: {
                  num: res.data.err
                }
              })
            } else {
              this.$messagebox({
                title: this.lang.tip,
                message: res.data.msg,
                confirmButtonText: this.lang.confirm
              });
            }
          })
          .catch(error => {
            this.$indicator.close();
            this.$messagebox({
              title: this.lang.tip,
              message: this.lang.conneterr,
              confirmButtonText: this.lang.confirm
            });
          })
      }
    }
  }
</script>
<style type="text/css"  scoped>
  .title {
    margin-top: 20px;
    padding-left: 20px;
    color: #333;
    font-size: 16px;
    font-weight: bold;
  }

  .item {
    margin: 12px 20px;
    padding: 10px 12px;
    border-radius: 6px;
    background: #f5f5f5;
    display: flex;
    align-items: center;
    color: #666;
    word-break: break-all;

    &.nobg{
      background: none;
      justify-content: center;
    }

    input{
      height: 30px;
    }

    .btn {
      color: #3476FE;
      margin-left: 20px;
    }

    .addimg {
      width: 150px;
      height: 150px;
      margin: auto;
      border: 2px dashed #ccc;
      border-radius: 3px;
      text-align: center;
      line-height: 150px;
    }

    .icon-tianjia {
      font-size: 40px;
      color: #999;
    }

    #filed {
      width: 1px;
      height: 1px;
      position: absolute;
      bottom: 10px;
      right: 10px;
      z-index: 0;
    }
  }

  .navbar {
    display: flex;
    padding: 20px 20px 0;
    align-items: center;

    span {
      padding: 5px 10px;
      color: #333;
      margin-right: 12px;

      &.active {
        border-radius: 5px;
        border: 1px solid #3476FE;
      }
    }
  }

  .next-btn {
    margin: 30px 12px;
    background: #3476FE;
    height: 46px;
    line-height: 46px;
    text-align: center;
    border-radius: 30px;
    color: #fff;
    font-weight: bold;
    font-size: 16px;
  }
</style>